import { useState } from 'react';
import { USDollar, USD_TO_CNY, sumUSDFormat, sumCNYFormat } from 'utils/format';
import { InvestorPositionsTableByAccountDetailed } from './InvestorPositionsTableByAccountDetailed';

export function InvestorPositionsTableByAccount(props) {
    const { positions, investors } = props;
    const [showDetail, setShowDetail] = useState(false);
    const [isHovered, setIsHovered] = useState(false);

    const usdPositions = positions.filter(
        (position) => position.currency.toLowerCase() === 'usd'
    );

    const cnyPositions = positions.filter(
        (position) => position.currency.toLowerCase() === 'cny'
    );

    return (
        <>
            {positions.length > 0 && (
                <div
                    style={{
                        display: 'flex',
                        fontWeight: 'bold',
                        borderBottom: showDetail ? '1px solid black' : '',
                        borderTop: '1px solid black',
                        width: 'fit-content',
                        cursor: 'pointer',
                        backgroundColor: isHovered
                            ? 'rgb(247, 247, 249)'
                            : 'white',
                    }}
                    onClick={() => setShowDetail(!showDetail)}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                >
                    <div
                        style={{
                            width: '50px',
                            textAlign: 'center',
                            alignContent: 'center',
                        }}
                    >
                        {showDetail ? '-' : '+'}
                    </div>

                    <div
                        style={{
                            width: '100px',
                            textAlign: 'center',
                            alignContent: 'center',
                        }}
                    >
                        {positions[0].account_name}
                    </div>

                    <div
                        style={{
                            width: '150px',
                            textAlign: 'center',
                            alignContent: 'center',
                        }}
                    >
                        {`${investors.length} investor${
                            investors.length > 1 ? 's' : ''
                        }`}
                    </div>

                    <div style={{ width: '100px', textAlign: 'center' }}></div>

                    <div style={{ width: '100px', textAlign: 'center' }}></div>

                    <div
                        style={{
                            width: '100px',
                            textAlign: 'center',
                            alignContent: 'center',
                        }}
                    >
                        <div>
                            {usdPositions.length > 0 &&
                                sumUSDFormat(usdPositions, 'investment_amount')}
                        </div>
                        <div>
                            {cnyPositions.length > 0 &&
                                sumCNYFormat(cnyPositions, 'investment_amount')}
                        </div>
                    </div>

                    <div
                        style={{
                            width: '100px',
                            textAlign: 'center',
                            alignContent: 'center',
                        }}
                    >
                        <div>
                            {usdPositions.length > 0 &&
                                sumUSDFormat(usdPositions, 'account_balance')}
                        </div>
                        <div>
                            {cnyPositions.length > 0 &&
                                sumCNYFormat(cnyPositions, 'account_balance')}
                        </div>
                    </div>

                    <div
                        style={{
                            width: '100px',
                            textAlign: 'center',
                            alignContent: 'center',
                        }}
                    >
                        <div>
                            {usdPositions.length > 0 &&
                                sumUSDFormat(usdPositions, 'interest_received')}
                        </div>
                        <div>
                            {cnyPositions.length > 0 &&
                                sumCNYFormat(cnyPositions, 'interest_received')}
                        </div>
                    </div>

                    <div
                        style={{
                            width: '100px',
                            textAlign: 'center',
                            alignContent: 'center',
                        }}
                    >
                        <div>
                            {usdPositions.length > 0 &&
                                sumUSDFormat(
                                    usdPositions,
                                    'principal_returned'
                                )}
                        </div>
                        <div>
                            {cnyPositions.length > 0 &&
                                sumCNYFormat(
                                    cnyPositions,
                                    'principal_returned'
                                )}
                        </div>
                    </div>
                </div>
            )}
            {showDetail && (
                <div style={{ display: 'flex' }}>
                    <div
                        style={{ width: '50px', textAlign: 'center' }}
                        onClick={() => setShowDetail(!showDetail)}
                    ></div>

                    <div style={{ width: '100px', textAlign: 'center' }}></div>

                    <div style={{ width: '150px', textAlign: 'center' }}>
                        {investors.map((investor, idx) => (
                            <div key={idx}>
                                <div>{investor.legal_name}</div>

                                <div style={{ fontSize: '10px' }}>
                                    {investor.email}
                                </div>
                            </div>
                        ))}
                    </div>
                    <InvestorPositionsTableByAccountDetailed
                        positions={positions}
                        usdPositions={usdPositions}
                        cnyPositions={cnyPositions}
                    />
                </div>
            )}
        </>
    );
}
